/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import { combineReducers } from 'redux'
import { browserHistory } from 'utils/navigation'
import { actions as notyActions } from 'layouts/ErrorBox'
import { addUniqToArr, countWordsInInstrument, downloadBlob, stripHtmlTags } from 'utils/misc'
import request, { generateNotyMessage } from 'utils/request'
import { getDiaryErrors, getFormulaErrors } from 'utils/instrumentValidation'
import {
  addMediaToFileMap,
  deleteMediaFromInstrumentJson,
  removeValuesAndLabels,
  removeChoices,
  getRandomizedArray,
  getDistinctQuestionTypes,
  addHasScoringMetadataFlag,
} from 'utils/instrument'
import { createMomentObject, getFormattedDateString } from 'utils/time'
import {
  DATE_FORMAT_MAP,
  INSTRUMENT_DISPLAY_LOCATION_OPTIONS,
  INPUT_VALIDATION_TYPE_MAP,
  INSTRUMENT_PATH_MAP,
  MEDIA_TYPE_MAP,
  MODAL_BUTTONS_MAP,
  MODAL_CLASSES_MAP,
  MODAL_CONTENT_MAP,
  NUMERIC_CHOICE_QUESTION_TYPES,
  QUESTION_TYPE_MAP,
  QUESTION_TYPES_WITH_AUDIO,
  QUESTION_TYPES_WITH_CHOICE_IMAGES,
  QUESTION_TYPES_WITH_CHOICES,
  QUESTION_TYPES_WITH_HINTS,
  QUESTION_TYPES_WITH_IMAGE,
  QUESTION_TYPES_WITH_SCORING,
  QUESTION_TYPES_WITH_VIDEO,
  QUESTION_TYPES_WITHOUT_QUESTION_NUMBERS,
  RELATIVE_DATE_INTERVAL_MAP,
  SCALE_QUESTION_TYPES,
  SELECT_QUESTION_TYPES,
} from 'utils/constants'
import { modalActions } from 'store/modal'
import { loadingActions } from 'store/loader'
import { getDomainIsUtilized } from '../../Scoring/utils/domainUtils'
import { _getDefaultMetadata } from '../../../../../utils/PropertyFields'
import { ensureCohortAudience, prepareScheduleForPayload } from '../../../modules/Instrument'
import { validateAndFixQuestionAndChoiceIdMismatches } from '../../EditSurvey/modules/Survey'
import { replaceTargetsWithVal } from '../../Scoring/utils/scoring'
import { getRandomQuestionId } from '../../../../../../../utils/getRandomQuestionId'
import {
  getStudyVersionID,
  hasMultiScheduleFeature,
  isVersionUatOrLive,
} from '../../../../../../../../../../../utils/studyConfigUtils'
import { prepareUploadedInstrumentData } from '../../../../../utils/uploadInstrumentPrep'
import STRINGS from 'utils/strings'

//
// Constants
//

// Diary
export const INITIALIZE_DIARY_EDIT = 'INITIALIZE_DIARY_EDIT'
const ADD_DIARY_CHOICE = 'ADD_DIARY_CHOICE'
const ADD_DIARY_CHOICE_LABEL_IMAGE = 'ADD_DIARY_CHOICE_LABEL_IMAGE'
const ADD_DIARY_CHOICE_ON_PASTE = 'ADD_DIARY_CHOICE_ON_PASTE'
const ADD_DIARY_ITEM = 'ADD_DIARY_ITEM'
const ADD_DIARY_ITEM_IMAGE = 'ADD_DIARY_ITEM_IMAGE'
const ADD_DIARY_ITEM_MEDIA = 'ADD_DIARY_ITEM_MEDIA'
const ADD_DIARY_LOGIC_CONDITION = 'ADD_DIARY_LOGIC_CONDITION'
const ADD_DIARY_LOGIC_GROUP = 'ADD_DIARY_LOGIC_GROUP'
const ADD_NEW_DIARY_DOMAIN = 'ADD_NEW_DIARY_DOMAIN'
const ADD_DIARY_OTHER_CHOICE = 'ADD_DIARY_OTHER_CHOICE'
const CHANGE_DIARY_ITEM_TYPE = 'CHANGE_DIARY_ITEM_TYPE'
const CHANGE_DIARY_LOGIC_OPERATOR = 'CHANGE_DIARY_LOGIC_OPERATOR'
const DELETE_ALL_DIARY_LOGIC = 'DELETE_ALL_DIARY_LOGIC'
const DELETE_DIARY_CHOICE = 'DELETE_DIARY_CHOICE'
const DELETE_DIARY_CHOICE_LABEL_IMAGE = 'DELETE_DIARY_CHOICE_LABEL_IMAGE'
const DELETE_DIARY_INVALID_LOGIC = 'DELETE_DIARY_INVALID_LOGIC'
const DELETE_DIARY_ITEM = 'DELETE_DIARY_ITEM'
const DELETE_DIARY_ITEM_IMAGE = 'DELETE_DIARY_ITEM_IMAGE'
const DELETE_DIARY_ITEM_MEDIA = 'DELETE_DIARY_ITEM_MEDIA'
const DELETE_DIARY_LOGIC_CONDITION = 'DELETE_DIARY_LOGIC_CONDITION'
const DELETE_DIARY_OTHER_CHOICE = 'DELETE_DIARY_OTHER_CHOICE'
const DELETE_DIARY_LONGLIST_ITEM = 'DELETE_DIARY_LONGLIST_ITEM'
const DUPLICATE_DIARY_ITEM = 'DUPLICATE_DIARY_ITEM'
const INITIALIZE_BLANK_DIARY = 'INITIALIZE_BLANK_DIARY'
const MOVE_DIARY_CHOICE = 'MOVE_DIARY_CHOICE'
const MOVE_DIARY_ITEM = 'MOVE_DIARY_ITEM'
const RANDOMIZE_DIARY_QUESTIONS = 'RANDOMIZE_DIARY_QUESTIONS'
const SET_DIARY_ITEM_SCORES_EDITED = 'SET_DIARY_ITEM_SCORES_EDITED'
const TOGGLE_DIARY_EDIT = 'TOGGLE_DIARY_EDIT'
const TOGGLE_DIARY_INPUT_VALIDATION = 'TOGGLE_DIARY_INPUT_VALIDATION'
const TOGGLE_DIARY_ITEM_DOMAIN = 'TOGGLE_DIARY_ITEM_DOMAIN'
const TOGGLE_DIARY_ITEM_HAS_SCORING = 'TOGGLE_DIARY_ITEM_HAS_SCORING'
const TOGGLE_DIARY_REQUIRED_QUESTION = 'TOGGLE_DIARY_REQUIRED_QUESTION'
const UPDATE_DIARY_CHOICE_KEY = 'UPDATE_DIARY_CHOICE_KEY'
const UPDATE_DIARY_CHOICE_LABEL = 'UPDATE_DIARY_CHOICE_LABEL'
const UPDATE_DIARY_CHOICE_RICH_LABEL = 'UPDATE_DIARY_CHOICE_RICH_LABEL'
const UPDATE_DIARY_CHOICE_SCORE_VALUE = 'UPDATE_DIARY_CHOICE_SCORE_VALUE'
const UPDATE_DIARY_CHOICE_VALUE = 'UPDATE_DIARY_CHOICE_VALUE'
const UPDATE_DIARY_ITEM = 'UPDATE_DIARY_ITEM'
const UPDATE_DIARY_ITEM_LABEL = 'UPDATE_DIARY_ITEM_LABEL'
const UPDATE_DIARY_LOGIC_CONDITION = 'UPDATE_DIARY_LOGIC_CONDITION'
const UPDATE_DIARY_LONG_LIST_ITEM = 'UPDATE_DIARY_LONG_LIST_ITEM'
const UPDATE_ORIGINAL_DIARY = 'UPDATE_ORIGINAL_DIARY'
const UPDATE_DIARY_OTHER_CHOICE = 'UPDATE_DIARY_OTHER_CHOICE'
const UPDATE_DIARY_TITLE = 'UPDATE_DIARY_TITLE'
const UPDATE_DIARY_UNIT_TYPE = 'UPDATE_DIARY_UNIT_TYPE'
const UPDATE_DIARY_DOMAIN_FORMULA = 'UPDATE_DIARY_DOMAIN_FORMULA'
const UPDATE_DIARY_ITEM_FORMULA = 'UPDATE_DIARY_ITEM_FORMULA'
const UPDATE_DIARY_SCORE = 'UPDATE_DIARY_SCORE'
const UPDATE_DIARY_LONGLIST_ITEM_BY_CSV = 'UPDATE_DIARY_LONGLIST_ITEM_BY_CSV'
const ADD_DIARY_SCORE = 'ADD_DIARY_SCORE'
const DELETE_DIARY_SCORE = 'DELETE_DIARY_SCORE'
const SET_DIARIES_SCORE = 'SET_DIARIES_SCORE'

// Errors
const ADD_DIARY_ERRORS = 'ADD_DIARY_ERRORS'
const CLEAR_DIARY_ERROR = 'CLEAR_DIARY_ERROR'
const CLEAR_DIARY_ERRORS = 'CLEAR_DIARY_ERRORS'
const CLEAR_DIARY_QUESTION_ERROR = 'CLEAR_DIARY_QUESTION_ERROR'

//
// Action Creators
//

// Diary Actions
function initializeEdit(json) {
  return {
    type: INITIALIZE_DIARY_EDIT,
    json,
  }
}

function initializeBlankDiary(title = '', displayName = '') {
  return {
    type: INITIALIZE_BLANK_DIARY,
    title,
    displayName,
  }
}

export function updateTitle(title) {
  return {
    type: UPDATE_DIARY_TITLE,
    title,
  }
}

// Item Actions

function toggleEdit(itemId) {
  return {
    type: TOGGLE_DIARY_EDIT,
    itemId,
  }
}

function addItem({ itemType, index, newQId }) {
  const choiceOneId = `${newQId}_${getRandomQuestionId()}`
  const choiceTwoId = `${newQId}_${getRandomQuestionId()}`
  return {
    type: ADD_DIARY_ITEM,
    itemType,
    newQId,
    index,
    choiceOneId,
    choiceTwoId,
  }
}

function deleteItem(itemId) {
  return {
    type: DELETE_DIARY_ITEM,
    itemId,
  }
}

function addItemImage({ itemId, imageId, imageSrc, size }) {
  return {
    type: ADD_DIARY_ITEM_IMAGE,
    itemId,
    imageId,
    imageSrc,
    size,
  }
}
function deleteItemImage(itemId, imageId) {
  return {
    type: DELETE_DIARY_ITEM_IMAGE,
    itemId,
    imageId,
  }
}
function addItemMedia({ isVideo, itemId, fileId, fileSrc, size }) {
  return {
    type: ADD_DIARY_ITEM_MEDIA,
    itemId,
    isVideo,
    fileId,
    fileSrc,
    size,
  }
}

function deleteItemMedia(itemId, fileId) {
  return {
    type: DELETE_DIARY_ITEM_MEDIA,
    itemId,
    fileId,
  }
}

function addChoice(itemId, choicesLength, insertIdx, itemType) {
  const newChoiceId = `${itemId}_${getRandomQuestionId()}`
  return {
    type: ADD_DIARY_CHOICE,
    itemId,
    insertIdx,
    choicesLength,
    itemType,
    newChoiceId,
  }
}

function addChoiceOnPaste(itemId, pasteText) {
  return {
    type: ADD_DIARY_CHOICE_ON_PASTE,
    itemId,
    pasteText,
  }
}

function addOtherChoice(itemId) {
  return {
    type: ADD_DIARY_OTHER_CHOICE,
    itemId,
  }
}

function deleteOtherChoice(itemId) {
  return {
    type: DELETE_DIARY_OTHER_CHOICE,
    itemId,
  }
}

function updateOtherChoice(item, itemId, otherValue) {
  return {
    type: UPDATE_DIARY_OTHER_CHOICE,
    item,
    itemId,
    otherValue,
  }
}

function deleteChoice(itemId, choiceId) {
  return {
    type: DELETE_DIARY_CHOICE,
    itemId,
    choiceId,
  }
}

function updateChoiceLabel(item, itemId, choiceId, newLabel) {
  return {
    type: UPDATE_DIARY_CHOICE_LABEL,
    item,
    itemId,
    choiceId,
    newLabel,
  }
}
function updateChoiceRichLabel(item, itemId, choiceId, value) {
  return {
    type: UPDATE_DIARY_CHOICE_RICH_LABEL,
    item,
    itemId,
    choiceId,
    value,
  }
}

function updateChoiceValue(item, itemId, choiceId, newValue) {
  return {
    type: UPDATE_DIARY_CHOICE_VALUE,
    item,
    itemId,
    choiceId,
    newValue,
  }
}

function updateChoiceScoreValue(item, itemId, choiceId, newValue) {
  return {
    type: UPDATE_DIARY_CHOICE_SCORE_VALUE,
    item,
    itemId,
    choiceId,
    newValue,
  }
}

function updateChoiceKey(item, itemId, choiceId, key, newValue) {
  return {
    type: UPDATE_DIARY_CHOICE_KEY,
    item,
    itemId,
    choiceId,
    key,
    newValue,
  }
}

function addChoiceLabelImage({ item, itemId, choiceId, imageId, imageSrc, size }) {
  return {
    type: ADD_DIARY_CHOICE_LABEL_IMAGE,
    item,
    itemId,
    choiceId,
    imageId,
    imageSrc,
    size,
  }
}

function deleteChoiceLabelImage(item, itemId, choiceId, imageId) {
  return {
    type: DELETE_DIARY_CHOICE_LABEL_IMAGE,
    item,
    itemId,
    choiceId,
    imageId,
  }
}

function moveChoice(itemId, startIdx, endIdx) {
  return {
    type: MOVE_DIARY_CHOICE,
    itemId,
    startIdx,
    endIdx,
  }
}

function changeItemType(itemId, prevType, nextType, _diary, newChoices) {
  const item = _diary.questions[itemId]
  return {
    type: CHANGE_DIARY_ITEM_TYPE,
    itemId,
    prevType,
    nextType,
    item,
    newChoices,
  }
}

function toggleRequiredQuestion(itemId) {
  return {
    type: TOGGLE_DIARY_REQUIRED_QUESTION,
    itemId,
  }
}

function toggleQuestionScoring(itemId, domains) {
  return {
    type: TOGGLE_DIARY_ITEM_HAS_SCORING,
    itemId,
    domains,
  }
}

function setQuestionScoresEdited(itemId) {
  return {
    type: SET_DIARY_ITEM_SCORES_EDITED,
    itemId,
  }
}

function toggleInputValidation(itemId) {
  return {
    type: TOGGLE_DIARY_INPUT_VALIDATION,
    itemId,
  }
}
function toggleQuestionDomain(itemId, domainId) {
  return {
    type: TOGGLE_DIARY_ITEM_DOMAIN,
    itemId,
    domainId,
  }
}

function createNewDomainAndAddToQuestion(itemId, label) {
  const newDomainId = getRandomQuestionId()
  return {
    type: ADD_NEW_DIARY_DOMAIN,
    itemId,
    label,
    newDomainId,
  }
}

function updateDiaryDomainFormula(domainId, formula) {
  return {
    type: UPDATE_DIARY_DOMAIN_FORMULA,
    domainId,
    formula,
  }
}

function updateDiaryScore(scoreId, key, value) {
  return {
    type: UPDATE_DIARY_SCORE,
    scoreId,
    key,
    value,
  }
}

function addDiaryScore(scoreId) {
  return {
    type: ADD_DIARY_SCORE,
    scoreId,
  }
}

function deleteDiaryScore(scoreId) {
  return {
    type: DELETE_DIARY_SCORE,
    scoreId,
  }
}

function moveItem(startIdx, endIdx) {
  return {
    type: MOVE_DIARY_ITEM,
    startIdx,
    endIdx,
  }
}

function updateItemFormula(itemId, formula) {
  return {
    type: UPDATE_DIARY_ITEM_FORMULA,
    itemId,
    formula,
  }
}

export function duplicateItem(itemId, choiceQProps) {
  const newQId = getRandomQuestionId()
  if (choiceQProps) {
    const { choicesOrder } = choiceQProps
    const newChoicesIdMap = {}
    choicesOrder.forEach(choiceId => {
      const newChoiceId = `${newQId}_${getRandomQuestionId()}`
      newChoicesIdMap[choiceId] = newChoiceId
    })
    return {
      type: DUPLICATE_DIARY_ITEM,
      hasChoices: true,
      choicesOrder,
      itemId,
      newChoicesIdMap,
      newQId,
    }
  }
  return {
    type: DUPLICATE_DIARY_ITEM,
    itemId,
    newQId,
  }
}

function updateUnitType(itemId, unit) {
  return {
    type: UPDATE_DIARY_UNIT_TYPE,
    itemId,
    unit,
  }
}

function randomizeQuestions() {
  return {
    type: RANDOMIZE_DIARY_QUESTIONS,
  }
}

function setDiariesScore(instrumentId, scores) {
  return {
    type: SET_DIARIES_SCORE,
    instrumentId,
    scores,
  }
}

// Error actions

function addDiaryErrors(errors) {
  return {
    type: ADD_DIARY_ERRORS,
    errors,
  }
}

function clearDiaryErrors() {
  return {
    type: CLEAR_DIARY_ERRORS,
  }
}

function clearQuestionError(itemId) {
  return {
    type: CLEAR_DIARY_QUESTION_ERROR,
    itemId,
  }
}

function checkLogicAndToggleRequired(diary, itemId) {
  return dispatch => {
    const invalidConditions = findInvalidLogicOnToggleRequired(diary.questions, diary.order[0], itemId)
    if (Object.keys(invalidConditions).length > 0) {
      const onConfirm = () => {
        dispatch(deleteInvalidLogic(invalidConditions))
        dispatch(toggleRequiredQuestion(itemId))
      }
      dispatch(
        modalActions.openModal({
          content: MODAL_CONTENT_MAP.actionInvalidate,
          confirmButton: MODAL_BUTTONS_MAP.proceed,
          cancelButton: MODAL_BUTTONS_MAP.cancel,
          className: MODAL_CLASSES_MAP.confirmation,
          onConfirm,
        }),
      )
    } else {
      dispatch(toggleRequiredQuestion(itemId))
    }
  }
}

function checkLogicAndDeleteItem(diary, itemId) {
  return dispatch => {
    let onConfirm = () => {
      dispatch(deleteItem(itemId))
    }
    let modalBody = {
      content: MODAL_CONTENT_MAP.deleteItem,
      confirmButton: MODAL_BUTTONS_MAP.yes,
      cancelButton: MODAL_BUTTONS_MAP.no,
    }
    const invalidConditions = findInvalidLogicOnDelete(diary.questions, diary.order[0], itemId)
    if (Object.keys(invalidConditions).length > 0) {
      onConfirm = () => {
        dispatch(deleteInvalidLogic(invalidConditions))
        dispatch(deleteItem(itemId))
      }
      modalBody = {
        content: MODAL_CONTENT_MAP.logicInvalidatedByMove,
        confirmButton: MODAL_BUTTONS_MAP.proceed,
        cancelButton: MODAL_BUTTONS_MAP.cancel,
      }
    }
    dispatch(
      modalActions.openModal({
        ...modalBody,
        className: MODAL_CLASSES_MAP.confirmation,
        onConfirm,
      }),
    )
  }
}

function checkLogicAndMoveItem(diary, startIdx, endIdx) {
  return dispatch => {
    const invalidConditions = findInvalidLogicOnMove(diary.questions, diary.order[0], startIdx, endIdx)
    if (Object.keys(invalidConditions).length > 0) {
      const onConfirm = () => {
        dispatch(deleteInvalidLogic(invalidConditions))
        dispatch(moveItem(startIdx, endIdx))
      }
      dispatch(
        modalActions.openModal({
          content: MODAL_CONTENT_MAP.logicInvalidatedByMove,
          confirmButton: MODAL_BUTTONS_MAP.proceed,
          cancelButton: MODAL_BUTTONS_MAP.cancel,
          className: MODAL_CLASSES_MAP.confirmation,
          onConfirm,
        }),
      )
    } else {
      dispatch(moveItem(startIdx, endIdx))
    }
  }
}

function checkLogicAndDeleteChoice(diary, itemId, choiceId) {
  return dispatch => {
    const invalidConditions = findInvalidLogicOnChoiceDelete(diary.questions, diary.order[0], itemId, choiceId)
    if (Object.keys(invalidConditions).length > 0) {
      const onConfirm = () => {
        dispatch(deleteInvalidLogic(invalidConditions))
        dispatch(deleteChoice(itemId, choiceId))
      }
      dispatch(
        modalActions.openModal({
          content: MODAL_CONTENT_MAP.logicInvalidatedByDeletion,
          confirmButton: MODAL_BUTTONS_MAP.proceed,
          cancelButton: MODAL_BUTTONS_MAP.cancel,
          className: MODAL_CLASSES_MAP.confirmation,
          onConfirm,
        }),
      )
    } else {
      dispatch(deleteChoice(itemId, choiceId))
    }
  }
}

function checkLogicAndChangeItemType(_diary, itemId, prevType, nextType) {
  const newChoices = {
    choiceIdOne: `${itemId}_${getRandomQuestionId()}`,
    choiceIdTwo: `${itemId}_${getRandomQuestionId()}`,
  }

  return dispatch => {
    const invalidConditions = findInvalidLogicOnChangeItemType(
      _diary.questions,
      _diary.order[0],
      itemId,
      prevType,
      nextType,
    )
    if (Object.keys(invalidConditions).length > 0) {
      const onConfirm = () => {
        dispatch(deleteInvalidLogic(invalidConditions))
        dispatch(changeItemType(itemId, prevType, nextType, _diary, newChoices))
      }
      dispatch(
        modalActions.openModal({
          content: MODAL_CONTENT_MAP.logicInvalidatedByType,
          confirmButton: MODAL_BUTTONS_MAP.proceed,
          cancelButton: MODAL_BUTTONS_MAP.cancel,
          className: MODAL_CLASSES_MAP.confirmation,
          onConfirm,
        }),
      )
    } else {
      dispatch(changeItemType(itemId, prevType, nextType, _diary, newChoices))
    }
  }
}

export function findInvalidLogicOnMove(questions, order, startIdx, endIdx) {
  const invalidConditions = {}
  if (startIdx > endIdx) {
    const itemId = order[startIdx]
    if (!questions[itemId].logic.show_if) return invalidConditions
    const currentItemRefs = {}
    logicForEach(questions[itemId].logic.show_if.terms, (term, path) => {
      currentItemRefs[term.question_id] = currentItemRefs[term.question_id] || []
      currentItemRefs[term.question_id].push(path)
    })
    for (let i = endIdx; i < startIdx; i++) {
      if (order[i] in currentItemRefs) {
        invalidConditions[itemId] = invalidConditions[itemId] || []
        invalidConditions[itemId] = invalidConditions[itemId].concat(currentItemRefs[order[i]])
      }
    }
  } else {
    for (let i = startIdx + 1; i <= endIdx; i++) {
      if (!questions[order[i]].logic.show_if) continue
      logicForEach(questions[order[i]].logic.show_if.terms, (term, path) => {
        if (term.question_id === order[startIdx]) {
          invalidConditions[order[i]] = invalidConditions[order[i]] || []
          invalidConditions[order[i]].push(path)
        }
      })
    }
  }
  return invalidConditions
}

export function findInvalidLogicOnDelete(questions, order, deleteId) {
  const invalidConditions = {}
  order.forEach(itemId => {
    if (!questions[itemId].logic.show_if) return
    logicForEach(questions[itemId].logic.show_if.terms, (term, path) => {
      if (deleteId === term.question_id) {
        invalidConditions[itemId] = invalidConditions[itemId] || []
        invalidConditions[itemId].push(path)
      }
    })
  })
  return invalidConditions
}

export function findInvalidLogicOnToggleRequired(questions, order, toggleId) {
  const invalidConditions = {}
  if (questions[toggleId].attributes.required) return invalidConditions
  order.forEach(itemId => {
    if (!questions[itemId].logic.show_if) return
    logicForEach(questions[itemId].logic.show_if.terms, (term, path) => {
      if (toggleId === term.question_id && term.comparator.includes('answered')) {
        invalidConditions[itemId] = invalidConditions[itemId] || []
        invalidConditions[itemId].push(path)
      }
    })
  })
  return invalidConditions
}

export function findInvalidLogicOnChoiceDelete(questions, order, itemId, choiceId) {
  const invalidConditions = {}
  order.forEach(itemId => {
    if (!questions[itemId].logic.show_if) return
    logicForEach(questions[itemId].logic.show_if.terms, (term, path) => {
      if (term.value === choiceId) {
        invalidConditions[itemId] = invalidConditions[itemId] || []
        invalidConditions[itemId].push(path)
      }
    })
  })
  return invalidConditions
}

export function findInvalidLogicOnChangeItemType(questions, order, itemId, prevType, nextType) {
  if (prevType === nextType) return {}
  const invalidConditions = {}
  const selectTypes = ['likert', 'select_one', 'select_multiple']
  if (!(selectTypes.includes(prevType) && selectTypes.includes(nextType))) {
    order.forEach(id => {
      if (!questions[id].logic.show_if) return
      logicForEach(questions[id].logic.show_if.terms, (term, path) => {
        if (!term.comparator.includes('answered') && term.question_id === itemId) {
          invalidConditions[id] = invalidConditions[id] || []
          invalidConditions[id].push(path)
        }
      })
    })
  }
  return invalidConditions
}

function logicForEach(terms, callback, path = []) {
  if (!terms) return
  terms.forEach((term, index) => {
    if (term.comparator === 'boolean_combine') {
      logicForEach(term.terms, callback, path.slice().concat(index))
    } else {
      callback(term, path.slice().concat(index))
    }
  })
}

function deleteInvalidLogic(invalidConditions) {
  return {
    type: DELETE_DIARY_INVALID_LOGIC,
    invalidConditions,
  }
}

function updateItemLabel(itemId, value) {
  return {
    type: UPDATE_DIARY_ITEM_LABEL,
    itemId,
    value,
  }
}

function updateItem(itemId, item) {
  return {
    type: UPDATE_DIARY_ITEM,
    itemId,
    item,
  }
}

function updateLongListItem(itemId, inputText) {
  return {
    type: UPDATE_DIARY_LONG_LIST_ITEM,
    itemId,
    inputText,
  }
}

function deleteLongListItem(itemId) {
  return {
    type: DELETE_DIARY_LONGLIST_ITEM,
    itemId,
  }
}

function updateLongListItemByCSV(itemId, longList) {
  return {
    type: UPDATE_DIARY_LONGLIST_ITEM_BY_CSV,
    itemId,
    longList,
  }
}

// Logic Actions
function updateLogicCondition(itemId, logic, conditionPath, field, value) {
  return {
    type: UPDATE_DIARY_LOGIC_CONDITION,
    itemId,
    conditionPath,
    field,
    value,
    logic,
  }
}

function addLogicCondition(itemId, groupPath) {
  return {
    type: ADD_DIARY_LOGIC_CONDITION,
    itemId,
    groupPath,
  }
}

function addLogicGroup(itemId) {
  return {
    type: ADD_DIARY_LOGIC_GROUP,
    itemId,
  }
}

function deleteLogicCondition(itemId, conditionPath) {
  return {
    type: DELETE_DIARY_LOGIC_CONDITION,
    itemId,
    conditionPath,
  }
}

function deleteAllLogic(itemId) {
  return {
    type: DELETE_ALL_DIARY_LOGIC,
    itemId,
  }
}

function changeLogicOperator(itemId, groupPath, value) {
  return {
    type: CHANGE_DIARY_LOGIC_OPERATOR,
    itemId,
    groupPath,
    value,
  }
}

// Diary API Functions

export const uploadImage = formData => {
  const success = payload => {
    const { full_path: src, image_id: imageId } = payload
    return {
      src,
      imageId,
    }
  }
  return dispatch => {
    return dispatch(
      request({
        method: 'POST',
        url: '/control/survey_image',
        contentType: 'multipart/form-data',
        body: formData,
        hasLoader: true,
        loadingKey: 'mediaUpload',
        success,
        successMessage: 'Image successfully uploaded.',
        catchMessage: 'There was a problem uploading the image. Please try again later.',
      }),
    )
  }
}

export const uploadMedia = formData => dispatch => {
  const success = payload => {
    const { full_path: src, file_id: fileId } = payload
    return {
      src,
      fileId,
    }
  }

  const fail = (response, content) => {
    dispatch(notyActions.showError({ text: generateNotyMessage(content.message, false) }))
    return Promise.resolve(false)
  }

  return dispatch(
    request({
      method: 'POST',
      url: '/control/survey_resource',
      contentType: 'multipart/form-data',
      body: formData,
      hasLoader: true,
      loadingKey: 'mediaUpload',
      success,
      fail,
      successMessage: 'Media successfully uploaded.',
      catchMessage: 'There was a problem uploading the media. Please try again later.',
    }),
  )
}

export const uploadChoicesCSV = (file, itemId) => dispatch => {
  const success = longList => {
    dispatch(deleteLongListItem(itemId))
    dispatch(updateLongListItemByCSV(itemId, longList))
  }

  const fail = (response, content) => {
    dispatch(notyActions.showError({ text: generateNotyMessage(content.message, false) }))
    return Promise.resolve(false)
  }
  return dispatch(
    request({
      method: 'POST',
      url: '/control/questions/upload_csv',
      body: file,
      success,
      fail,
      successMessage: 'CSV successfully uploaded.',
      catchMessage: 'There was a problem uploading the file. Please try again later.',
      hasLoader: true,
      contentType: 'text/csv',
    }),
  )
}

export function downloadChoicesCSV({ question = {} }) {
  return dispatch => {
    const url = '/control/questions/download_csv'
    const success = (blob, fileName) => {
      downloadBlob(blob, `question_choices.csv`, fileName)
    }
    return dispatch(
      request({
        url,
        body: JSON.stringify(question),
        method: 'POST',
        resType: 'blob',
        success,
      }),
    )
  }
}

export function fetchDiary(studyID, instrumentId, version, useLoader) {
  return (dispatch, getState) => {
    const versionText = version ? `?version=${version}` : ''
    function success(json) {
      prepareDiary(json)
        .then(result => {
          const { formattedJSON } = result
          calcQuestionNumbers(formattedJSON.order, formattedJSON.questions)
          return Promise.resolve({ formattedJSON })
        })
        .then(result => {
          const { formattedJSON: _formattedJSON } = result
          dispatch(initializeEdit(_formattedJSON))
          let errors = getDiaryErrors(_formattedJSON)
          if (_formattedJSON?.scores?.length) {
            errors = {
              ...errors,
              ...getFormulaErrors(_formattedJSON),
            }
          }
          dispatch(setDiariesScore(instrumentId, _formattedJSON?.scores))
          dispatch(addDiaryErrors(errors))

          const { location } = getState()
          const path = location.pathname.match(/([^/]+$)/)[0]
          const isScoringPage = path === INSTRUMENT_PATH_MAP.scoring

          // Render a noty to alert user there are score errors if there are
          if (isScoringPage && !!errors.scores) {
            dispatch(
              notyActions.showError({
                text: generateNotyMessage('Please check errors before proceeding.', false),
              }),
            )
          }

          return Promise.resolve()
        })
        .then(() => {
          dispatch(loadingActions.stopLoader(true))
        })
    }

    function fail(res) {
      dispatch(loadingActions.stopLoader(true))
      throw new Error(`${res.status} ${res.statusText} when fetching instrument`)
    }

    if (!useLoader) dispatch(loadingActions.startLoader(true))

    return dispatch(
      request({
        method: 'GET',
        url: `/control/admin/studies/${studyID}/instruments/${instrumentId}/ediary.json${versionText}`,
        success,
        fail,
      }),
    )
  }
}

export function validateDiaryAndSave({ studyID, diaryEditor, onRedirect, redirect, path }) {
  return dispatch => {
    let errors = getDiaryErrors(diaryEditor.diary)

    /**
     * This boolean is created to allow users to save the instrument even if there are formula
     * errors if they are not navigating to or from the scoring page.
     */
    const isScoringPath = [redirect, path].includes(INSTRUMENT_PATH_MAP.scoring)
    const formulaErrors = getFormulaErrors(diaryEditor.diary)

    if (diaryEditor.diary?.scores?.length && isScoringPath) {
      errors = {
        ...errors,
        ...formulaErrors,
      }
    }

    const redirectIsScoring = redirect === 'scoring'
    const hasScoringErrors = !!errors.scores && Object.keys(errors.scores).length > 0
    const hasQuestionErrors = Object.keys(errors.questions).length > 0
    const hasAnyError = Object.keys(errors).length > 1

    const valid = !(hasScoringErrors || hasQuestionErrors || hasAnyError)

    if (valid) {
      // remove [] used as marker for end of domain ID
      diaryEditor.diary.scores = diaryEditor.diary.scores.map(score => {
        return {
          ...score,
          formula: replaceTargetsWithVal(score.formula, ['[]'], ''),
        }
      })
    }
    if (hasScoringErrors && redirectIsScoring && !hasQuestionErrors) {
      dispatch(saveDiaryToDatabase({ studyID, ...diaryEditor }))
        .then(onRedirect)
        .then(() => {
          dispatch(addDiaryErrors(errors))
        })
    } else if (valid) {
      dispatch(clearDiaryErrors())
      dispatch(saveDiaryToDatabase({ studyID, ...diaryEditor })).then(onRedirect)
    } else {
      dispatch(addDiaryErrors(errors))
      dispatch(
        notyActions.showError({
          text: generateNotyMessage('Please check errors before proceeding.', false),
        }),
      )
    }
  }
}

export function _saveDiary(studyID, body, diaryID, isDiary = true) {
  let reqBody = body
  if (diaryID) {
    const { data } = body
    reqBody = data
  }
  return (dispatch, getState) => {
    const { study, location } = getState()
    const { studyVersionList } = study
    const studyVersionID = getStudyVersionID(location)
    const hasStudyPromotion = !!study?.currentStudy?.config?.study_promotion
    const isReadOnlyState = hasStudyPromotion && isVersionUatOrLive(studyVersionList, studyVersionID)

    const url =
      diaryID === undefined
        ? `/control/v2/studies/${studyID}/instruments`
        : `/control/studies/${studyID}/instruments/${diaryID}/ediary.json`

    return dispatch(
      request({
        url,
        body: isDiary ? body : JSON.stringify(reqBody),
        method: diaryID ? 'PUT' : 'POST',
        successMessage: !isReadOnlyState ? 'Instrument saved successfully' : '',
        hasLoader: true,
        failMessage: 'Failed to save instrument to database.',
        success: json => json,
        fail: json => json,
      }),
    )
  }
}

export function saveDiaryToDatabase({ diary: _diary, studyID }) {
  return (dispatch, getState) => {
    const { location, instrumentReducer } = getState()
    const studyVersionID = getStudyVersionID(location)
    const diaryJSON = JSON.parse(JSON.stringify(_diary))
    cleanUpDiary(diaryJSON)

    /**
     * This function will resolve any mismatches between a question's ID and
     * its choices' IDs.
     *  */
    validateAndFixQuestionAndChoiceIdMismatches(diaryJSON)

    diaryJSON.metadata.display_name = diaryJSON.metadata.display_name || diaryJSON.title
    const { instrument } = instrumentReducer
    const defaultDisplayLocation = [INSTRUMENT_DISPLAY_LOCATION_OPTIONS.carousel]
    if (!diaryJSON.metadata.display_location?.length) {
      diaryJSON.metadata.display_location =
        instrument?.metadata?.display_location?.length ? instrument.metadata.display_location : defaultDisplayLocation
      diaryJSON.metadata.placement = diaryJSON.metadata.display_location
    }
    diaryJSON.metadata.question_types = getDistinctQuestionTypes(diaryJSON)
    diaryJSON.metadata.display_score_to_participant =
      instrumentReducer?.instrument?.metadata?.display_score_to_participant ??
      diaryJSON.metadata.display_score_to_participant ??
      false
    // Persist display_score_to_participant on each score node.
    if (Array.isArray(diaryJSON.scores)) {
      diaryJSON.scores = diaryJSON.scores.map(score => ({
        ...score,
        display_score_to_participant:
          score.display_score_to_participant ?? diaryJSON.metadata.display_score_to_participant,
      }))
    }
    let imageList = []
    const requiredPermissions = []
    for (const qId in diaryJSON.questions) {
      const question = diaryJSON.questions[qId]
      const { hasScoring } = question.attributes
      if (question.type === QUESTION_TYPE_MAP.audioRecording) {
        if (!requiredPermissions.includes(QUESTION_TYPE_MAP.audioRecording))
          requiredPermissions.push(QUESTION_TYPE_MAP.audioRecording)
      }
      const { questionsWithScoring } = diaryJSON
      const { domains } = question

      // logic to handle domains and scoring
      if (!QUESTION_TYPES_WITH_SCORING.includes(question.type)) {
        if (hasScoring) {
          delete question.attributes.hasScoring
          delete question.formula
          delete questionsWithScoring[qId]
          if (domains) {
            domains.forEach(domainId => {
              const domainIsNotUsedByInstrument = !getDomainIsUtilized({ questionsWithScoring, domainId })
              if (domainIsNotUsedByInstrument) {
                delete diaryJSON.domains[domainId]
              }
            })
          }
          delete question.domains
          delete question.formula
        }
      } else if (!hasScoring) {
        delete question.attributes.hasScoring
        delete question.formula
        delete questionsWithScoring[qId]
        if (domains) {
          domains.forEach(domainId => {
            const domainIsNotUsedByInstrument = !getDomainIsUtilized({ questionsWithScoring, domainId })
            if (domainIsNotUsedByInstrument) {
              delete diaryJSON.domains[domainId]
            }
          })
        }
        delete question.domains
        delete question.formula
      } else if (question.type !== QUESTION_TYPE_MAP.selectMultiple) {
        delete question.formula
      }

      // remove unused attributes exclusive to certain question types
      if (!QUESTION_TYPES_WITH_HINTS.includes(question.type)) {
        delete question.hint
      }
      if (!SCALE_QUESTION_TYPES.includes(question.type)) {
        delete question.scale_labels
      }
      if (question.type !== QUESTION_TYPE_MAP.audioRecording) {
        delete question.attributes.min
      }

      if (question.image) imageList = [...imageList, question.image]
      for (const choiceId in question.choices) {
        const choice = question.choices[choiceId]
        if (!hasScoring) {
          delete choice.score_value
        } else {
          const { score_value } = choice
          if (score_value || score_value === 0) choice.score_value = Number(choice.score_value)
          else choice.score_value = ''
        }
        if (question.type === QUESTION_TYPE_MAP.multipleField) {
          if (!question.attributes.hasCharLimit) {
            // deletes a choice's min and max key if the question does not have input validation
            delete choice.max
            delete choice.min
          } else if (
            (choice.max === '' || choice.max === undefined) &&
            (choice.min === '' || choice.min === undefined)
          ) {
            delete choice.max
            delete choice.min
          } else if ((choice.max === '' || choice.max === undefined) && choice.min !== '') {
            choice.max = 999999999
          } else if ((choice.min === '' || choice.min === undefined) && choice.max !== '') {
            choice.min = 0
          }
          if (choice.type === 'text') delete choice.min
          const choiceLabel = choice.label
          choice.choice_label = choiceLabel
          delete choice.label
        }
        if (choice.image) {
          imageList = [...imageList, choice.image]
        }
      }
      if (question.input_validation) {
        if (question.input_validation.absolute_date) {
          const { min, max } = question.input_validation.absolute_date
          if (min) {
            question.input_validation.absolute_date.min = getFormattedDateString(min, DATE_FORMAT_MAP.datePicker, true)
          }
          if (max) {
            question.input_validation.absolute_date.max = getFormattedDateString(max, DATE_FORMAT_MAP.datePicker, true)
          }
        }
      }
    }
    if (imageList.length) {
      const uniqImageList = [...new Set(imageList)]
      diaryJSON.image_list = uniqImageList
    }
    diaryJSON.required_permissions = requiredPermissions
    addHasScoringMetadataFlag(diaryJSON)
    if (diaryJSON.metadata?.schedule) {
      diaryJSON.metadata.schedule = prepareScheduleForPayload(diaryJSON.metadata.schedule)
    }

    addImagesInChoices(diaryJSON.questions)

    ensureCohortAudience(diaryJSON)

    function success(resJSON) {
      if (!resJSON.ok && resJSON.status === 412) {
        dispatch(
          modalActions.openModal({
            content: MODAL_CONTENT_MAP.logicInvalidatedByDeletion,
            confirmButton: MODAL_BUTTONS_MAP.goInstrumentPage,
            className: MODAL_CLASSES_MAP.confirmation,
            onConfirm: () => {
              browserHistory.push(`/studies/${studyID}/${studyVersionID}/instruments`)
            },
          }),
        )
      } else {
        dispatch({
          type: UPDATE_ORIGINAL_DIARY,
          json: _diary,
        })
      }
      return Promise.resolve(resJSON)
    }

    const body = JSON.stringify(_diary.id ? diaryJSON : { data: diaryJSON, format: 'json' })
    return dispatch(_saveDiary(studyID, body, _diary.id)).then(success)
  }
}

export function saveUploadToDatabase(studyID, uploadedDiary) {
  return (dispatch, getState) => {
    const { participants, user, study, location } = getState()
    const studyVersionID = getStudyVersionID(location)
    const hasStudyPromotion = !!study?.currentStudy?.config?.study_promotion
    const hasMultiSchedule = hasMultiScheduleFeature(study?.currentStudy)

    let data
    try {
      data = JSON.parse(uploadedDiary.data)
      validateAndFixQuestionAndChoiceIdMismatches(data)
      data = prepareUploadedInstrumentData({
        data,
        hasMultiSchedule,
        participants,
        user,
        studyId: studyID,
      })
    } catch (err) {
      if (err?.isMultiScheduleUploadRejected) {
        dispatch(
          notyActions.showError({
            text: generateNotyMessage(STRINGS.multiScheduleUploadNotAllowed, false),
          }),
        )
      }
      return Promise.reject(err)
    }

    if (data.metadata.schedule) {
      data.metadata.schedule = prepareScheduleForPayload(data.metadata.schedule)
    }
    data.metadata.question_types = getDistinctQuestionTypes(data)
    addHasScoringMetadataFlag(data)
    ensureCohortAudience(data)

    const body = {
      format: uploadedDiary.format,
      data,
      study_version_id: hasStudyPromotion ? studyVersionID : undefined,
    }

    return dispatch(_saveDiary(studyID, body, uploadedDiary.id, null))
  }
}


//
// State Generators
//

function generateBlankDiary(initialTitle, displayName) {
  return {
    title: initialTitle || '',
    type: 'EDIARY',
    metadata: _getDefaultMetadata('EDIARY', displayName),
    order: [[]],
    questions: {},
    questionsWithScoring: {},
    image_list: [],
    resource_list: [],
    resource_size_list: [],
    scores: [],
  }
}

//
// Util Functions
//

// this creates image elements that will render in the diary editor

const imageRegex = /<img src(.*)\/>/g
const pOpen = /<p>/g
const pClose = /<\/p>/g

const removeImageElementFromLabel = label => {
  let newLabel = label.slice()
  newLabel = newLabel.replace(imageRegex, '')
  newLabel = newLabel.replace(pOpen, '')
  newLabel = newLabel.replace(pClose, '')
  return newLabel
}

export function prepareDiary(json) {
  for (const qId in json.questions) {
    // convert note to introduction
    const question = json.questions[qId]
    if (question.type === 'note') {
      question.type = 'introduction'
    } else if (question.type === 'select_one' && question.attributes.appearance === 'likert') {
      question.type = 'likert'
    } else if (question.type === 'audio_recording' && question.attributes.show_timer === undefined) {
      question.attributes.show_timer = true
    }
    if (question.attributes.hasScoring && !question.formula) {
      question.formula = 'MEAN'
    }
    delete question.attributes.appearance
    // encapsulate logic conditions if they aren't in a boolean combine
    if (Object.keys(question.logic).length > 0 && question.logic.show_if.comparator !== 'boolean_combine') {
      question.logic.show_if = {
        comparator: 'boolean_combine',
        operator: 'and',
        terms: [question.logic.show_if],
      }
    }

    const { choices_order, image, resources } = question
    if (image) {
      addMediaToFileMap({ _instrument: json, fileId: image, itemId: qId })
    } else if (resources) {
      const { audio, video } = resources
      addMediaToFileMap({ _instrument: json, fileId: audio || video, itemId: qId })
    }
    if (choices_order) {
      choices_order.forEach(choiceId => {
        const choice = question.choices[choiceId]
        const { score_value } = choice
        if (choice.image) {
          choice.label = removeImageElementFromLabel(choice.label)
          addMediaToFileMap({ _instrument: json, fileId: choice.image, itemId: qId })
        }
        if (score_value || score_value === 0) choice.score_value = score_value.toString()
        if (question.type === QUESTION_TYPE_MAP.multipleField) {
          const choiceLabel = choice.choice_label
          choice.label = choiceLabel
          delete choice.choice_label
        }
      })
    }
    delete json.required_permissions

    if (
      question.input_validation &&
      (question.input_validation.absolute_date ||
        (question.type === QUESTION_TYPE_MAP.datetime && question.input_validation.absolute_time))
    ) {
      json.questions[qId].input_validation.isExactRangeTab = true
      // absolute_time-only datetime questions may not have absolute_date
      if (question.input_validation.absolute_date) {
        const { min, max } = question.input_validation.absolute_date
        if (min) {
          json.questions[qId].input_validation.absolute_date.min = createMomentObject(min).toDate()
        }
        if (max) {
          json.questions[qId].input_validation.absolute_date.max = createMomentObject(max).toDate()
        }
      }
    }
  }

  if (!json.questionsWithScoring) {
    json.questionsWithScoring = {}
  }
  if (!json.scores) {
    json.scores = []
  }

  Object.keys(json.questionsWithScoring).forEach(qId => {
    const question = json.questions[qId]
    if (!question) return
    question.attributes = question.attributes || {}
    if (!question.attributes.hasScoring) {
      question.attributes.hasScoring = true
      if (!question.formula) question.formula = 'MEAN'
    }
  })

  return Promise.resolve({
    formattedJSON: json,
  })
}

function cleanUpDiary(_diary) {
  // Remove unnecessary fields
  delete _diary.activeItemId
  for (const qId in _diary.questions) {
    removeValuesAndLabels(_diary.questions[qId])
    removeChoices(_diary.questions[qId])
    delete _diary.questions[qId].images
    delete _diary.questions[qId].label_images
    delete _diary.questions[qId].attributes.canHaveLogic
    delete _diary.questions[qId].attributes.questionNumber

    if (_diary.questions[qId].input_validation) {
      if (_diary.questions[qId].input_validation.isExactRangeTab) {
        delete _diary.questions[qId].input_validation.relative
      } else if ([QUESTION_TYPE_MAP.date, QUESTION_TYPE_MAP.datetime].includes(_diary.questions[qId].type)) {
        delete _diary.questions[qId].input_validation.absolute_date
        delete _diary.questions[qId].input_validation.absolute_time
      }

      delete _diary.questions[qId].input_validation.isExactRangeTab

      for (const key of Object.keys(_diary.questions[qId].input_validation)) {
        for (const validationKey of Object.keys(_diary.questions[qId].input_validation[key])) {
          if (_diary.questions[qId].input_validation[key][validationKey] === '') {
            delete _diary.questions[qId].input_validation[key][validationKey]
            if (validationKey === RELATIVE_DATE_INTERVAL_MAP.preceding) {
              delete _diary.questions[qId].input_validation[key].preceding_interval_type
            }
            if (validationKey === RELATIVE_DATE_INTERVAL_MAP.succeeding) {
              delete _diary.questions[qId].input_validation[key].succeeding_interval_type
            }
          }
        }
        if (
          ![
            INPUT_VALIDATION_TYPE_MAP.decimalPlaces,
            INPUT_VALIDATION_TYPE_MAP.min,
            INPUT_VALIDATION_TYPE_MAP.max,
          ].includes(key) &&
          !Object.keys(_diary.questions[qId].input_validation[key]).length
        ) {
          delete _diary.questions[qId].input_validation[key]
        }
        if (
          key === INPUT_VALIDATION_TYPE_MAP.relative &&
          Object.keys(_diary.questions[qId].input_validation[key]).length === 1
        ) {
          delete _diary.questions[qId].input_validation[key]
        }
        if (_diary.questions[qId].input_validation[key] === '') {
          delete _diary.questions[qId].input_validation[key]
        }
      }
      if (!Object.keys(_diary.questions[qId].input_validation).length) {
        delete _diary.questions[qId].input_validation
      }
    }
  }
  if (Object.keys(_diary.questionsWithScoring).length === 0) {
    _diary.scores = []
  }
}

function addImagesInChoices(questions) {
  for (const key in questions) {
    const question = questions[key]
    if (SELECT_QUESTION_TYPES.includes(question.type)) {
      question.choices_order.forEach(choiceId => {
        const choice = question.choices[choiceId]
        // add image element to label if there is a choice label image
        if (choice.image) choice.label = `${choice.label}<img src="${choice.image}"/>`
      })
    }
  }
}

export function calcQuestionNumbers(order, questions) {
  let count = 0
  order[0].forEach(id => {
    if (!QUESTION_TYPES_WITHOUT_QUESTION_NUMBERS.includes(questions[id].type)) {
      count++
      questions[id].attributes.questionNumber = count
      questions[id].attributes.canHaveLogic = count > 1
    } else {
      questions[id].attributes.canHaveLogic = count >= 1
    }
  })
}

function dupStateAndItem(state, itemId) {
  const newState = { ...state }
  newState.questions = { ...newState.questions }
  newState.questions[itemId] = { ...newState.questions[itemId] }
  return newState
}
function dupStateAndItemAndChoice(state, itemId, choiceId) {
  // spread operator is only shallow copy hence the need for this func
  const newState = { ...state }
  newState.questions = { ...newState.questions }
  newState.questions[itemId] = { ...newState.questions[itemId] }
  newState.questions[itemId].choices[choiceId] = { ...newState.questions[itemId].choices[choiceId] }
  return newState
}

function getCondition(terms, conditionPath) {
  if (conditionPath.length === 1) {
    return terms[conditionPath[0]]
  }
  return getCondition(terms[conditionPath[0]].terms, conditionPath.slice(1))
}

function setCondition(terms, conditionPath, newValue) {
  if (conditionPath.length === 1) {
    terms[conditionPath[0]] = newValue
  } else {
    setCondition(terms[conditionPath[0]].terms, conditionPath.slice(1), newValue)
  }
}

function addCondition(terms, groupPath) {
  if (groupPath.length === 1) {
    terms[groupPath[0]].terms.push({
      question_type: '',
      question_id: '',
      value: '',
      comparator: '',
    })
  } else {
    addCondition(terms[groupPath[0]].terms, groupPath.slice(1))
  }
}

function deleteCondition(showIf, conditionPath) {
  if (conditionPath.length === 1) {
    showIf.terms.splice(conditionPath[0], 1)
  } else {
    deleteCondition(showIf.terms[conditionPath[0]], conditionPath.slice(1))
    if (showIf.terms[conditionPath[0]].terms.length === 0) {
      showIf.terms.splice(conditionPath[0], 1)
    }
  }
}

function removeLoneGroup(logic) {
  if (logic.show_if.terms.length < 1) {
    delete logic.show_if
  } else if (logic.show_if.terms[0].comparator === 'boolean_combine' && logic.show_if.terms.length === 1) {
    logic.show_if.terms = logic.show_if.terms[0].terms
  }
}

function setOperator(logic, groupPath, value) {
  if (groupPath.length === 0) {
    logic.operator = value
  } else {
    setOperator(logic.terms[groupPath[0]], groupPath.slice(1), value)
  }
}

function generateNewScoreObject(id = getRandomQuestionId()) {
  return {
    id,
    name: '',
    description: '',
    formula: '',
    tagFormula: '',
  }
}

//
// Reducers
//

export function diary(state = generateBlankDiary(), action) {
  switch (action.type) {
    case INITIALIZE_BLANK_DIARY: {
      return generateBlankDiary(action.title, action.displayName)
    }
    case INITIALIZE_DIARY_EDIT: {
      return action.json
    }
    case UPDATE_DIARY_TITLE: {
      return { ...state, title: action.title }
    }
    case TOGGLE_DIARY_EDIT: {
      const newState = { ...state }
      newState.activeItemId = action.itemId
      return newState
    }
    case UPDATE_DIARY_ITEM: {
      const newState = dupStateAndItem(state, action.itemId)
      Object.assign(newState.questions[action.itemId], action.item)
      return newState
    }
    case UPDATE_DIARY_LONG_LIST_ITEM: {
      const newState = dupStateAndItem(state, action.itemId)
      const question = newState.questions[action.itemId]
      const newChoices = {}
      const newChoicesOrder = []
      action.inputText.split('\n').forEach(line => {
        const newChoiceId = `${action.itemId}_${getRandomQuestionId()}`
        newChoices[newChoiceId] = { label: line }
        newChoicesOrder.push(newChoiceId)
      })
      question.choices = newChoices
      question.choices_order = newChoicesOrder
      question.choices_text = action.inputText
      return newState
    }
    case DELETE_DIARY_LONGLIST_ITEM: {
      const newState = dupStateAndItem(state, action.itemId)
      const question = newState.questions[action.itemId]
      question.choices = {}
      question.choices_order = []
      question.choices_text = ''
      return newState
    }
    case UPDATE_DIARY_LONGLIST_ITEM_BY_CSV: {
      const { itemId, longList } = action
      const newState = dupStateAndItem(state, itemId)
      const question = newState.questions[itemId]

      const choicesText = longList.join('\n')

      const longListObj = longList.reduce((prevObj, currentValue, currentIndex) => {
        const newChoiceId = `${itemId}_${getRandomQuestionId()}`
        return {
          ...prevObj,
          [currentIndex]: { [newChoiceId]: { label: currentValue } },
        }
      }, {})
      const longListValues = Object.values(longListObj)
      const choices = longListValues.reduce((prevObj, value) => {
        return {
          ...prevObj,
          [Object.keys(value).flat()]: Object.values(value)[0],
        }
      }, {})
      const choiceOrder = longListValues.map(objKey => Object.keys(objKey)).flat()

      question.choices = choices
      question.choices_order = choiceOrder
      question.choices_text = choicesText

      return newState
    }
    case UPDATE_DIARY_ITEM_LABEL: {
      const newState = dupStateAndItem(state, action.itemId)
      const question = newState.questions[action.itemId]
      question.label = action.value

      // If audio/video was removed from the label HTML, clear resources so media
      // does not persist after save / reload.
      const { resources } = question
      if (resources) {
        const { audio, video } = resources
        const label = action.value || ''
        const audioRemoved = audio && !/<audio\b/i.test(label)
        const videoRemoved = video && !/<video\b/i.test(label)
        if (audioRemoved || videoRemoved) {
          const fileId = audio || video
          delete question.resources
          delete question.mediaSrc
          deleteMediaFromInstrumentJson({
            _instrument: newState,
            fileId,
            itemId: action.itemId,
            isImage: false,
          })
        }
      }

      return newState
    }
    case CHANGE_DIARY_ITEM_TYPE: {
      const newState = dupStateAndItem(state, action.itemId)
      const question = newState.questions[action.itemId]
      question.type = action.nextType

      if (action.prevType === action.newType) return newState

      if (!QUESTION_TYPES_WITH_SCORING.includes(action.nextType)) {
        const { domains } = question
        const { hasScoring } = question.attributes
        if (hasScoring) {
          delete question.attributes.hasScoring
          delete question.formula
          delete newState.questionsWithScoring[action.itemId]
          if (domains) {
            domains.forEach(domainId => {
              const domainIsNotUsedByInstrument = !getDomainIsUtilized({
                questionsWithScoring: newState.questionsWithScoring,
                domainId,
              })
              if (domainIsNotUsedByInstrument) {
                delete newState.domains[domainId]
              }
            })
          }
          delete question.domains
          delete question.formula
        }
      }

      if (SELECT_QUESTION_TYPES.includes(action.prevType)) {
        if (!SELECT_QUESTION_TYPES.includes(action.nextType)) {
          action.item.choices_order?.forEach(choiceId => {
            const choice = action.item.choices?.[choiceId]
            if (!choice) return
            const newLabel = stripHtmlTags(choice.label ?? '')
            if (!question.choices[choiceId]) {
              question.choices[choiceId] = { ...choice }
            }
            question.choices[choiceId].label = newLabel
            if (action.nextType === QUESTION_TYPE_MAP.longListSelectOne) {
              question.choices[choiceId].label = newLabel.replace(/\n/g, ' ')
            }
          })
        }
      }

      if (action.prevType === QUESTION_TYPE_MAP.longListSelectOne) {
        delete question.choices_text
      }

      if (!QUESTION_TYPES_WITH_CHOICES.includes(action.prevType)) {
        question.choices = {} // the choice(s) from multipleFields need to be cleared
        question.choices_order = []

        const { choiceIdOne, choiceIdTwo } = action.newChoices
        question.choices[choiceIdOne] = { label: '' }
        question.choices_order.push(choiceIdOne)
        question.choices[choiceIdTwo] = { label: '' }
        question.choices_order.push(choiceIdTwo)
      }

      if (SELECT_QUESTION_TYPES.includes(action.nextType)) {
        delete question.attributes.other
        while (question.choices_order.length < 2) {
          // when a question type is changed to select type, the question is given a minimum of two choices
          const newChoiceId = `${action.itemId}_${getRandomQuestionId()}`
          question.choices[newChoiceId] = { label: '' }
          question.choices_order.push(newChoiceId)
        }
        question.choices_order.forEach(choiceId => {
          delete question.choices[choiceId].value
        })
      }
      if (action.nextType === QUESTION_TYPE_MAP.longListSelectOne) {
        const choicesTextArr = []
        while (question.choices_order.length < 10) {
          const newChoiceId = `${action.itemId}_${getRandomQuestionId()}`
          question.choices[newChoiceId] = { label: '' }
          question.choices_order.push(newChoiceId)
          question.choices_text += '\n'
        }
        question.choices_order.forEach(choiceId => {
          const choice = question.choices[choiceId]
          choicesTextArr.push(choice.label)
          delete question.choices[choiceId].value
        })
        question.choices_text = choicesTextArr.join('\n')
      }
      if (action.nextType === QUESTION_TYPE_MAP.likert) {
        delete question.attributes.other
        while (question.choices_order.length < 5) {
          // when a question type is changed to likert, the question is given a minimum of five choices
          const newChoiceId = `${action.itemId}_${getRandomQuestionId()}`
          question.choices[newChoiceId] = { label: '' }
          question.choices_order.push(newChoiceId)
        }
        if (question.choices_order.length > 7) {
          question.choices_order.length = 7
        } else if (question.choices_order.length === 6) {
          const newChoiceId = action.itemId + getRandomQuestionId()
          question.choices[newChoiceId] = { label: '' }
          question.choices_order.push(newChoiceId)
        }
      }

      if (action.nextType === QUESTION_TYPE_MAP.numericRatingScale) {
        delete question.attributes.other

        /*
         * this prevents the uncontolled input error that occurs when multipleField questions
         * don't have value (the value inside the button)
         */
        if (
          [
            QUESTION_TYPE_MAP.selectOne,
            QUESTION_TYPE_MAP.selectMultiple,
            QUESTION_TYPE_MAP.likert,
            QUESTION_TYPE_MAP.numericRatingScale,
          ].includes(action.prevType)
        ) {
          question.choices_order.forEach(choiceId => {
            question.choices[choiceId].value = ''
          })
        }

        while (question.choices_order.length < 2) {
          // when a question type is changed to numeric rating scale type, the question is given a minimum of two choices
          const newChoiceId = `${action.itemId}_${getRandomQuestionId()}`
          question.choices[newChoiceId] = { label: '' }
          question.choices_order.push(newChoiceId)
        }
        if (question.choices_order.length > 11) {
          question.choices_order.length = 11
        }
      }
      if (action.nextType === QUESTION_TYPE_MAP.multipleField) {
        question.choices = {} // deletes all previous choices, and creates a new choice with a blank label and default type of 'text'
        question.choices_order = []
        delete question.attributes.other
        while (question.choices_order.length < 1) {
          const newChoiceId = `${action.itemId}_${getRandomQuestionId()}`
          question.choices[newChoiceId] = { label: '', type: 'text' }
          question.choices_order.push(newChoiceId)
        }
        question.attributes.inputWidth = 'medium'
      } else {
        delete question.attributes.inputWidth
      }

      if (action.nextType === QUESTION_TYPE_MAP.vaScale || action.nextType === QUESTION_TYPE_MAP.vaScale2021) {
        question.scale_labels = {
          top: '',
          bottom: '',
        }
      }

      if (!QUESTION_TYPES_WITH_HINTS.includes(action.nextType)) {
        delete question.hint
      }

      if (action.nextType === QUESTION_TYPE_MAP.vasHorizontal) {
        question.scale_labels = {
          top_value: '100',
          top: '',
          mid_value: '50',
          mid: '',
          bottom_value: '0',
          bottom: '',
        }
        question.hint = ''
      }

      if (!SCALE_QUESTION_TYPES.includes(action.nextType)) {
        delete question.scale_labels
      }

      if (action.nextType === QUESTION_TYPE_MAP.audioRecording) {
        question.attributes.min = ''
        question.attributes.show_timer = true
        question.attributes.required = true
      } else {
        delete question.attributes.min
        delete question.attributes.max
        delete question.attributes.show_timer
      }

      if (!QUESTION_TYPES_WITH_CHOICES.includes(question.type)) {
        question.choices = {}
        question.choices_order = []
      }

      if (['integer', 'decimal'].includes(action.prevType) && !['integer', 'decimal'].includes(action.nextType)) {
        delete question.attributes.unit
      }

      delete question.input_validation

      /**
       * Removing media if the new item type does not suppport media
       *  */

      // Removing images
      if (
        QUESTION_TYPES_WITH_IMAGE.includes(action.prevType) &&
        action?.item?.image &&
        !QUESTION_TYPES_WITH_IMAGE.includes(action.nextType)
      ) {
        const fileName = newState.questions[action.itemId].image
        delete newState.questions[action.itemId].image
        delete newState.questions[action.itemId].imageSrc

        deleteMediaFromInstrumentJson({ _instrument: newState, fileId: fileName, itemId: action.itemId })
      }
      // Removing video or audio
      if (
        (QUESTION_TYPES_WITH_VIDEO.includes(action.prevType) &&
          action?.item?.resources?.video &&
          !QUESTION_TYPES_WITH_VIDEO.includes(action.nextType)) ||
        (QUESTION_TYPES_WITH_AUDIO.includes(action.prevType) &&
          action?.item?.resources?.audio &&
          !QUESTION_TYPES_WITH_AUDIO.includes(action.nextType))
      ) {
        const { audio } = action.item.resources
        const fileName = newState.questions[action.itemId].resources[audio ? 'audio' : 'video']

        deleteMediaFromInstrumentJson({
          _instrument: newState,
          fileId: fileName,
          itemId: action.itemId,
          isImage: false,
        })

        delete newState.questions[action.itemId].resources
        delete newState.questions[action.itemId].mediaSrc
      }
      // Removing images from choices
      if (!QUESTION_TYPES_WITH_CHOICE_IMAGES.includes(action.nextType)) {
        action.item.choices_order.forEach(choiceId => {
          const fileName = action.item.choices[choiceId].image
          if (fileName) {
            deleteMediaFromInstrumentJson({ _instrument: newState, fileId: fileName, itemId: action.itemId })

            if (newState.questions[action.itemId].choices[choiceId]?.image) {
              delete newState.questions[action.itemId].choices[choiceId].image
              delete newState.questions[action.itemId].choices[choiceId].imageSrc
            }
          }
        })
      }

      // Remove 'type' key from non-multiple_field questions
      if (
        action.prevType === QUESTION_TYPE_MAP.multipleField &&
        QUESTION_TYPES_WITH_CHOICES.includes(action.nextType)
      ) {
        question.choices_order.forEach(choiceId => {
          delete question.choices[choiceId].type
        })
      }

      return newState
    }
    case UPDATE_DIARY_UNIT_TYPE: {
      const newState = dupStateAndItem(state, action.itemId)
      if (!action.unit) {
        delete newState.questions[action.itemId].attributes.unit
      } else {
        newState.questions[action.itemId].attributes.unit = action.unit
      }
      return newState
    }
    case TOGGLE_DIARY_REQUIRED_QUESTION: {
      const newState = dupStateAndItem(state, action.itemId)
      newState.questions[action.itemId].attributes.required = !newState.questions[action.itemId].attributes.required
      return newState
    }
    case TOGGLE_DIARY_ITEM_HAS_SCORING: {
      const newState = dupStateAndItem(state, action.itemId)
      const nextHasScoringState = !newState.questions[action.itemId].attributes.hasScoring
      newState.questions[action.itemId].attributes.hasScoring = nextHasScoringState
      newState.questions[action.itemId].formula = 'MEAN'

      if (nextHasScoringState) {
        newState.questionsWithScoring = {
          ...newState.questionsWithScoring,
          [action.itemId]: action.domains,
        }
      } else {
        delete newState.questionsWithScoring[action.itemId]
      }
      return newState
    }
    case SET_DIARY_ITEM_SCORES_EDITED: {
      const newState = dupStateAndItem(state, action.itemId)
      newState.questions[action.itemId].attributes.nonDefaultScoring = true
      return newState
    }
    case TOGGLE_DIARY_INPUT_VALIDATION: {
      const newState = dupStateAndItem(state, action.itemId)
      newState.questions[action.itemId].attributes.hasCharLimit = !newState.questions[action.itemId].attributes
        .hasCharLimit
      return newState
    }
    case ADD_DIARY_ITEM: {
      const newState = { ...state }
      if (action.index === undefined) {
        newState.order[0].push(action.newQId)
      } else {
        newState.order[0].splice(action.index + 1, 0, action.newQId)
      }
      newState.questions[action.newQId] = {
        type: action.itemType,
        label: '',
        choices: {},
        choices_order: [],
        attributes: { required: true, hasCharLimit: false },
        logic: {},
      }
      if (action.itemType === QUESTION_TYPE_MAP.selectOne) {
        const question = newState.questions[action.newQId]
        delete question.attributes.other
        question.choices[action.choiceOneId] = { label: '<p><br></p>' }
        question.choices_order.push(action.choiceOneId)
        question.choices[action.choiceTwoId] = { label: '<p><br></p>' }
        question.choices_order.push(action.choiceTwoId)
      }
      calcQuestionNumbers(newState.order, newState.questions)
      newState.activeItemId = action.newQId
      return newState
    }
    case DELETE_DIARY_ITEM: {
      const newState = { ...state }
      const { questionsWithScoring } = newState
      const question = newState.questions[action.itemId]
      const { domains } = question
      delete newState.questionsWithScoring[action.itemId]
      if (domains?.length) {
        domains.forEach(domainId => {
          const domainIsNotUsedByInstrument = !getDomainIsUtilized({ questionsWithScoring, domainId })
          if (domainIsNotUsedByInstrument) delete newState.domains[domainId]
        })
        const { domains: diaryDomains } = newState
        // If there are no domains, delete all the scores
        if (Object.keys(diaryDomains).length === 0) newState.scores = []
      }

      // Delete question's media data from survey if not being used in another question
      const { image, resources } = question
      if (image) {
        deleteMediaFromInstrumentJson({
          _instrument: newState,
          fileId: image,
          itemId: action.itemId,
        })
      } else if (resources) {
        const { audio } = resources
        const fileName = newState.questions[action.itemId].resources[audio ? 'audio' : 'video']
        deleteMediaFromInstrumentJson({
          _instrument: newState,
          fileId: fileName,
          itemId: action.itemId,
          isImage: false,
        })
      }

      if (QUESTION_TYPES_WITH_CHOICE_IMAGES.includes(question.type)) {
        question.choices_order.forEach(choiceId => {
          const choice = question.choices[choiceId]
          const fileName = choice?.image
          if (fileName) {
            deleteMediaFromInstrumentJson({ _instrument: newState, fileId: fileName, itemId: action.itemId })
          }
        })
      }

      delete newState.questions[action.itemId]
      newState.order[0].splice(newState.order[0].indexOf(action.itemId), 1)
      calcQuestionNumbers(newState.order, newState.questions)
      if (action.itemId === newState.activeItemId) {
        newState.activeItemId = null
      }
      return newState
    }
    case ADD_DIARY_ITEM_IMAGE: {
      const newState = { ...state }
      if (!action.imageId) return newState
      const { resource_size_list } = newState
      newState.image_list = newState.image_list ? addUniqToArr(newState.image_list, action.imageId) : [action.imageId]
      newState.questions[action.itemId].image = action.imageId
      newState.questions[action.itemId].imageSrc = action.imageSrc
      const fileResourceObject = {
        file_name: action.imageId,
        size: action.size,
        type: MEDIA_TYPE_MAP.image,
      }
      if (resource_size_list) resource_size_list.push(fileResourceObject)
      else newState.resource_size_list = [fileResourceObject]
      addMediaToFileMap({ _instrument: newState, fileId: action.imageId, itemId: action.itemId })

      return newState
    }
    case DELETE_DIARY_ITEM_IMAGE: {
      const newState = { ...state }
      delete newState.questions[action.itemId].image
      delete newState.questions[action.itemId].imageSrc

      deleteMediaFromInstrumentJson({
        _instrument: newState,
        fileId: action.imageId,
        itemId: action.itemId,
      })

      return newState
    }
    case ADD_DIARY_ITEM_MEDIA: {
      const newState = { ...state }
      const { resource_size_list } = newState
      newState.resource_list = newState.resource_list
        ? addUniqToArr(newState.resource_list, action.fileId)
        : [action.fileId]
      if (action.isVideo) {
        newState.questions[action.itemId].resources = { video: action.fileId }
      } else {
        newState.questions[action.itemId].resources = { audio: action.fileId }
      }
      newState.questions[action.itemId].mediaSrc = action.fileSrc
      const fileResourceObject = {
        file_name: action.fileId,
        size: action.size,
        type: action.isVideo ? MEDIA_TYPE_MAP.video : MEDIA_TYPE_MAP.audio,
      }
      if (resource_size_list) resource_size_list.push(fileResourceObject)
      else newState.resource_size_list = [fileResourceObject]
      addMediaToFileMap({ _instrument: newState, fileId: action.fileId, itemId: action.itemId })

      return newState
    }
    case DELETE_DIARY_ITEM_MEDIA: {
      const newState = { ...state }
      const { fileId, itemId } = action
      delete newState.questions[action.itemId].resources
      delete newState.questions[action.itemId].mediaSrc
      deleteMediaFromInstrumentJson({ _instrument: newState, fileId, itemId, isImage: false })

      return newState
    }
    case MOVE_DIARY_ITEM: {
      const newState = { ...state }
      newState.order = newState.order.slice()
      newState.questions = { ...newState.questions }
      newState.order[0].splice(action.endIdx, 0, newState.order[0].splice(action.startIdx, 1)[0])
      calcQuestionNumbers(newState.order, newState.questions)
      return newState
    }
    case DUPLICATE_DIARY_ITEM: {
      const newState = { ...state }
      newState.order = newState.order.slice()
      newState.questions = { ...newState.questions }
      newState.questions[action.newQId] = JSON.parse(JSON.stringify(newState.questions[action.itemId]))
      const newIndex = newState.order[0].indexOf(action.itemId) + 1
      newState.order[0].splice(newIndex, 0, action.newQId)
      calcQuestionNumbers(newState.order, newState.questions)
      const question = newState.questions[action.itemId]
      const { hasScoring } = question.attributes
      if (hasScoring) newState.questionsWithScoring[action.newQId] = question.domains
      if (action.hasChoices) {
        const duplicateQuestion = newState.questions[action.newQId]
        const newChoicesOrder = action.choicesOrder.map(choiceId => action.newChoicesIdMap[choiceId])
        duplicateQuestion.choices_order = newChoicesOrder
        action.choicesOrder.forEach(choiceId => {
          const newChoiceId = action.newChoicesIdMap[choiceId]
          duplicateQuestion.choices[newChoiceId] = JSON.parse(JSON.stringify(duplicateQuestion.choices[choiceId]))
          delete duplicateQuestion.choices[choiceId]
        })
      }
      /**
       * If the duplicated question has any media, we need to add the new question ID of
       * the duplicated question item to the file_map
       */
      const { type } = question
      if (QUESTION_TYPES_WITH_IMAGE.includes(type)) {
        const { image } = question
        if (newState.file_map) {
          if (image && newState.file_map[image]) {
            addMediaToFileMap({ _instrument: newState, fileId: image, itemId: action.newQId })
          }
          if (QUESTION_TYPES_WITH_CHOICE_IMAGES.includes(newState.questions[action.itemId].type)) {
            newState.questions[action.itemId].choices_order.forEach(choiceId => {
              const { image: choiceImage } = newState.questions[action.itemId].choices[choiceId]
              if (choiceImage && newState.file_map[choiceImage]) {
                addMediaToFileMap({ _instrument: newState, fileId: choiceImage, itemId: action.newQId })
              }
            })
          }
        }
      }
      if (QUESTION_TYPES_WITH_AUDIO.includes(type) || QUESTION_TYPES_WITH_VIDEO.includes(type)) {
        const { resources } = question
        if (resources) {
          const { audio, video } = resources
          addMediaToFileMap({ _instrument: newState, fileId: audio || video, itemId: action.newQId })
        }
      }
      return newState
    }
    case ADD_DIARY_CHOICE: {
      const newState = dupStateAndItem(state, action.itemId)
      newState.questions[action.itemId].choices[action.newChoiceId] = { label: '' }
      if (action.itemType === QUESTION_TYPE_MAP.longListSelectOne) {
        newState.questions[action.itemId].choices_text += '\n' // add a blank space to the text
      }
      if (action.itemType === QUESTION_TYPE_MAP.numericRatingScale) {
        newState.questions[action.itemId].choices[action.newChoiceId].value = ''
      }
      if (action.itemType === QUESTION_TYPE_MAP.multipleField) {
        newState.questions[action.itemId].choices[action.newChoiceId].type = 'text'
      }
      if (action.insertIdx) {
        newState.questions[action.itemId].choices_order.splice(action.insertIdx, 0, action.newChoiceId)
      } else {
        newState.questions[action.itemId].choices_order.push(action.newChoiceId)
      }
      return newState
    }
    case ADD_DIARY_CHOICE_ON_PASTE: {
      if (action.pasteText === '') return state
      const newState = dupStateAndItem(state, action.itemId)
      action.pasteText.split('\n').forEach(line => {
        const newChoiceId = `${action.itemId}_${getRandomQuestionId()}`
        newState.questions[action.itemId].choices[newChoiceId] = { label: line }
        newState.questions[action.itemId].choices_order.push(newChoiceId)
      })
      return newState
    }
    case ADD_DIARY_OTHER_CHOICE: {
      const newState = dupStateAndItem(state, action.itemId)
      newState.questions[action.itemId].attributes.other = 'Other'
      return newState
    }
    case DELETE_DIARY_OTHER_CHOICE: {
      const newState = dupStateAndItem(state, action.itemId)
      delete newState.questions[action.itemId].attributes.other
      return newState
    }
    case UPDATE_DIARY_OTHER_CHOICE: {
      const newState = dupStateAndItem(state, action.itemId)
      newState.questions[action.itemId].attributes.other = action.otherValue
      return newState
    }
    case DELETE_DIARY_CHOICE: {
      const newState = dupStateAndItem(state, action.itemId)
      const question = newState.questions[action.itemId]
      delete question.choices[action.choiceId]
      question.choices_order.splice(question.choices_order.indexOf(action.choiceId), 1)
      if (question.type === QUESTION_TYPE_MAP.longListSelectOne) {
        const textArr = question.choices_text.split('\n')
        textArr.pop() // remove the last choice text
        question.choices_text = textArr.join('\n')
      }
      return newState
    }
    case UPDATE_DIARY_CHOICE_LABEL: {
      const newState = dupStateAndItem(state, action.itemId)
      newState.questions[action.itemId].choices[action.choiceId].label = action.newLabel
      return newState
    }
    case UPDATE_DIARY_CHOICE_RICH_LABEL: {
      const newState = dupStateAndItemAndChoice(state, action.itemId, action.choiceId)
      newState.questions[action.itemId].choices[action.choiceId].label = action.value
      return newState
    }
    case UPDATE_DIARY_CHOICE_VALUE: {
      const newState = dupStateAndItem(state, action.itemId)
      newState.questions[action.itemId].choices[action.choiceId].value = action.newValue
      return newState
    }
    case UPDATE_DIARY_CHOICE_SCORE_VALUE: {
      const newState = dupStateAndItem(state, action.itemId)
      newState.questions[action.itemId].choices[action.choiceId].score_value = action.newValue
      return newState
    }
    case UPDATE_DIARY_CHOICE_KEY: {
      const newState = dupStateAndItem(state, action.itemId)
      newState.questions[action.itemId].choices[action.choiceId][action.key] = action.newValue
      if (action.key === 'type' && action.newValue === 'text') {
        // deletes a choice's min key if, the type is changed to text, this is important
        // for the text's max value because the input is made so that the max value cannot
        // be less than the min value
        delete newState.questions[action.itemId].choices[action.choiceId].min
      }
      return newState
    }
    case ADD_DIARY_CHOICE_LABEL_IMAGE: {
      const newState = dupStateAndItem(state, action.itemId)
      if (!action.imageId) return newState
      const { image_list, resource_size_list } = newState
      newState.image_list = image_list ? addUniqToArr(newState.image_list, action.imageId) : [action.imageId]
      newState.questions[action.itemId].choices[action.choiceId].image = action.imageId
      newState.questions[action.itemId].choices[action.choiceId].imageSrc = action.imageSrc
      const fileResourceObject = {
        file_name: action.imageId,
        size: action.size,
        type: MEDIA_TYPE_MAP.image,
      }
      if (resource_size_list) resource_size_list.push(fileResourceObject)
      else {
        newState.resource_size_list = [fileResourceObject]
      }
      addMediaToFileMap({ _instrument: newState, fileId: action.imageId, itemId: action.itemId })
      return newState
    }
    case DELETE_DIARY_CHOICE_LABEL_IMAGE: {
      const newState = dupStateAndItem(state, action.itemId)
      delete newState.questions[action.itemId].choices[action.choiceId].image
      delete newState.questions[action.itemId].choices[action.choiceId].imageSrc
      deleteMediaFromInstrumentJson({
        _instrument: newState,
        fileId: action.imageId,
        itemId: action.itemId,
      })
      return newState
    }
    case MOVE_DIARY_CHOICE: {
      const newState = dupStateAndItem(state, action.itemId)
      newState.questions[action.itemId].choices_order.splice(
        action.endIdx,
        0,
        newState.questions[action.itemId].choices_order.splice(action.startIdx, 1)[0],
      )
      return newState
    }
    case UPDATE_DIARY_LOGIC_CONDITION: {
      const newState = dupStateAndItem(state, action.itemId)
      const newCondition = Object.assign(
        getCondition(newState.questions[action.itemId].logic.show_if.terms, action.conditionPath),
        { [action.field]: action.value },
      )
      if (action.field === 'question_id') {
        newCondition.question_type = newState.questions[action.value].type
        newCondition.comparator = ''
        newCondition.value = ''
      } else if (action.field === 'comparator' && action.value.includes('answered')) {
        newCondition.value = ''
      }
      setCondition(newState.questions[action.itemId].logic.show_if.terms, action.conditionPath, newCondition)
      return newState
    }
    case ADD_DIARY_LOGIC_CONDITION: {
      const newState = dupStateAndItem(state, action.itemId)
      const blankCondition = {
        question_type: '',
        question_id: '',
        value: '',
        comparator: '',
      }
      if (action.groupPath) {
        addCondition(newState.questions[action.itemId].logic.show_if.terms, action.groupPath)
        return newState
      }
      if (newState.questions[action.itemId].logic.show_if) {
        newState.questions[action.itemId].logic.show_if.terms.push(blankCondition)
      } else {
        newState.questions[action.itemId].logic.show_if = {
          comparator: 'boolean_combine',
          operator: 'and',
          terms: [blankCondition],
        }
      }
      return newState
    }
    case ADD_DIARY_LOGIC_GROUP: {
      const newState = dupStateAndItem(state, action.itemId)
      const blankGroup = {
        comparator: 'boolean_combine',
        operator: 'and',
        terms: [
          {
            question_type: '',
            question_id: '',
            value: '',
            comparator: '',
          },
        ],
      }
      if (newState.questions[action.itemId].logic.show_if.terms[0].comparator !== 'boolean_combine') {
        newState.questions[action.itemId].logic.show_if.terms = [
          {
            comparator: 'boolean_combine',
            operator: 'and',
            terms: newState.questions[action.itemId].logic.show_if.terms,
          },
          blankGroup,
        ]
      } else {
        newState.questions[action.itemId].logic.show_if.terms.push(blankGroup)
      }
      return newState
    }
    case DELETE_DIARY_LOGIC_CONDITION: {
      const nextState = dupStateAndItem(state, action.itemId)
      deleteCondition(nextState.questions[action.itemId].logic.show_if, action.conditionPath)
      removeLoneGroup(nextState.questions[action.itemId].logic)
      return nextState
    }
    case DELETE_ALL_DIARY_LOGIC: {
      const newState = dupStateAndItem(state, action.itemId)
      delete newState.questions[action.itemId].logic.show_if
      return newState
    }
    case CHANGE_DIARY_LOGIC_OPERATOR: {
      const newState = dupStateAndItem(state, action.itemId)
      setOperator(newState.questions[action.itemId].logic.show_if, action.groupPath, action.value)
      return newState
    }
    case DELETE_DIARY_INVALID_LOGIC: {
      const nextState = { ...state }
      for (const itemId in action.invalidConditions) {
        nextState.questions[itemId] = { ...nextState.questions[itemId] }
        action.invalidConditions[itemId].sort((a, b) => {
          return b[0] - a[0] || b[1] - a[1]
        })
        action.invalidConditions[itemId].forEach(path => {
          deleteCondition(nextState.questions[itemId].logic.show_if, path)
        })
        removeLoneGroup(nextState.questions[itemId].logic)
      }
      return nextState
    }
    case RANDOMIZE_DIARY_QUESTIONS: {
      const newState = { ...state }
      newState.order[0] = getRandomizedArray(newState.order[0])
      Object.keys(newState.questions).forEach(qId => {
        newState.questions[qId].logic = {}
      })
      calcQuestionNumbers(newState.order, newState.questions)
      return newState
    }
    case ADD_NEW_DIARY_DOMAIN: {
      const nextState = { ...state }
      const { domains } = nextState
      const { newDomainId } = action

      if (!domains) nextState.domains = {}
      nextState.domains[newDomainId] = {
        label: action.label,
        formula: 'SUM',
      }

      const question = nextState.questions[action.itemId]
      const { domains: questionDomains } = question

      if (questionDomains) {
        question.domains.push(newDomainId)
      } else {
        question.domains = [newDomainId]
      }

      nextState.questionsWithScoring[action.itemId] = question.domains
      return nextState
    }
    case TOGGLE_DIARY_ITEM_DOMAIN: {
      const nextState = { ...state }
      const { questionsWithScoring } = nextState
      const question = nextState.questions[action.itemId]
      const { domains = [] } = question
      let newDomains = []

      if (domains.includes(action.domainId)) {
        newDomains = domains.filter(_domainId => _domainId !== action.domainId)
      } else {
        newDomains = [...domains, action.domainId]
      }
      question.domains = newDomains
      nextState.questionsWithScoring[action.itemId] = newDomains // update questionsWithScoring with new domain list

      /**
       * If the admin toggles off a domain from a question, we do a check to see if the domain
       * is assigned to any other question. If it is not, we delete the domain.
       */
      const domainIsNotUsedByInstrument = !getDomainIsUtilized({ questionsWithScoring, domainId: action.domainId })
      if (domainIsNotUsedByInstrument) {
        delete nextState.domains[action.domainId]
      }
      const { domains: diaryDomains } = nextState
      // If there are no domains, delete all the scores
      if (Object.keys(diaryDomains).length === 0) nextState.scores = []
      return nextState
    }
    case UPDATE_DIARY_ITEM_FORMULA: {
      const nextState = { ...state }
      nextState.questions[action.itemId].formula = action.formula
      return nextState
    }
    case UPDATE_DIARY_DOMAIN_FORMULA: {
      const nextState = { ...state }
      nextState.domains[action.domainId] = {
        ...nextState.domains[action.domainId],
        formula: action.formula,
      }
      return nextState
    }
    case UPDATE_DIARY_SCORE: {
      const nextState = { ...state }
      const { key, scoreId, value } = action
      const scoreIdx = state.scores.findIndex(score => score.id === scoreId)
      nextState.scores[scoreIdx] = {
        ...nextState.scores[scoreIdx],
        [key]: value,
      }
      return nextState
    }
    case ADD_DIARY_SCORE: {
      const nextState = { ...state }
      if (!nextState.scores) {
        nextState.scores = []
      }
      nextState.scores = [...nextState.scores, generateNewScoreObject(action.scoreId)]
      return nextState
    }
    case DELETE_DIARY_SCORE: {
      const nextState = { ...state }
      nextState.scores = nextState.scores.filter(score => score.id !== action.scoreId)
      return nextState
    }
    default: {
      return state
    }
  }
}

export function diaryErrors(state = { questions: {} }, action) {
  let newState
  switch (action.type) {
    case INITIALIZE_DIARY_EDIT:
    case INITIALIZE_BLANK_DIARY:
    case CLEAR_DIARY_ERRORS:
      return { questions: {} }
    case ADD_DIARY_ERRORS:
      return action.errors
    case CLEAR_DIARY_ERROR:
      newState = { ...state }
      delete newState[action.key]
      return newState
    case CLEAR_DIARY_QUESTION_ERROR:
    case CHANGE_DIARY_ITEM_TYPE:
      newState = { ...state }
      newState.questions = { ...newState.questions }
      delete newState.questions[action.itemId]
      return newState
    default:
      return state
  }
}

function originalDiary(state = {}, action) {
  if (action.type === INITIALIZE_DIARY_EDIT || action.type === UPDATE_ORIGINAL_DIARY) {
    return JSON.parse(JSON.stringify(action.json))
  }
  return state
}

function diariesScore(state = {}, action) {
  switch (action.type) {
    case SET_DIARIES_SCORE: {
      return {
        ...state,
        [action.instrumentId]: action.scores,
      }
    }
    default: {
      return state
    }
  }
}

const domainCachereducer = (state, action) => {
  state.domains = state.domains || {}
  if (state.domains[action.domainId] && action.type === TOGGLE_DIARY_ITEM_DOMAIN) {
    const formulas = state.scores.map(s => s.tagFormula)
    state.deletedDomains = { ...state.deletedDomains, [action.domainId]: state.domains[action.domainId] }

    state.deletedDomains = Object.keys(state.deletedDomains)
      .filter(tagId => formulas.map(f => f.includes(tagId)).some(b => b))
      .reduce((acc, k) => ({ ...acc, [k]: state.deletedDomains[k] }), {})
  }
  return state
}

const diaryEditorReducer = combineReducers({
  diary(state = generateBlankDiary(), action) {
    return diary(domainCachereducer(state, action), action)
  },
  diaryErrors,
  diariesScore,
  originalDiary,
  wordCount: (state = 0) => state,
})

export default (state, action) => {
  const nextState = diaryEditorReducer(state, action)
  return {
    ...nextState,
    wordCount: countWordsInInstrument(nextState.diary),
  }
}

export const diaryActions = {
  addItem,
  addItemImage,
  addItemMedia,
  clearQuestionError,
  closeModal: modalActions.closeModal,
  deleteChoice: checkLogicAndDeleteChoice,
  deleteItem: checkLogicAndDeleteItem,
  deleteItemImage,
  deleteItemMedia,
  downloadChoicesCSV,
  uploadChoicesCSV,
  fetchDiary,
  initializeBlankDiary,
  moveItem: checkLogicAndMoveItem,
  openModal: modalActions.openModal,
  randomizeQuestions,
  toggleEdit,
  updateTitle,
}

export const itemActions = {
  updateItemLabel,
  duplicateItem,
  addItem,
  addChoiceOnPaste,
  updateItem,
  updateLongListItem,
  deleteLongListItem,
  updateLongListItemByCSV,
}

export const itemEditorActions = {
  addChoice,
  addOtherChoice,
  changeItemType: checkLogicAndChangeItemType,
  createNewDomainAndAddToQuestion,
  deleteChoice: checkLogicAndDeleteChoice,
  moveItem: checkLogicAndMoveItem,
  toggleInputValidation,
  toggleQuestionDomain,
  toggleQuestionScoring,
  toggleRequiredQuestion: checkLogicAndToggleRequired,
  updateItem,
  updateItemFormula,
  updateUnitType,
}

export const selectViewActions = {
  addChoice,
  addChoiceLabelImage,
  deleteChoiceLabelImage,
  moveChoice,
  setQuestionScoresEdited,
  updateChoiceLabel,
  updateChoiceRichLabel,
  updateChoiceScoreValue,
  updateChoiceValue,
  updateChoiceKey,
  deleteOtherChoice,
  updateOtherChoice,
  deleteChoice: checkLogicAndDeleteChoice,
}

export const logicActions = {
  updateLogicCondition,
  addLogicCondition,
  deleteLogicCondition,
  deleteAllLogic,
  changeLogicOperator,
  addLogicGroup,
}

export const mediaActions = {
  uploadImage,
  uploadMedia,
  addItemMedia,
  deleteItemMedia,
}

export const scoringActions = {
  updateDiaryDomainFormula,
  updateDiaryScore,
  addDiaryScore,
  deleteDiaryScore,
}
